import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from '@tanstack/react-router';
import { DropdownMenu, Hint, RowActionsMenu, Switch, toast } from '@wit-support/ui';
import { adsManagerHref, launchPageHref } from '../format.js';
import { NO_PERM_TITLE, useAdsCampaignsPerms } from '../perms.js';
async function copyId(id) {
    try {
        await navigator.clipboard.writeText(id);
        toast.success('ID скопирован');
    }
    catch {
        toast.error('Не удалось скопировать ID');
    }
}
const KIND_LABEL = {
    campaign: 'кампании',
    adset: 'группы',
    ad: 'объявления',
};
/** Почему тумблер закрыт — одной фразой; `null` — открыт. */
export function toggleBlockedReason(row, h, perms) {
    if (row.gone)
        return 'Объект в архиве или удалён — включить или остановить его нельзя.';
    if (h.pastDay)
        return 'Показан прошлый день: статусы всегда текущие, поэтому тумблер недоступен. Вернитесь на «Сегодня».';
    if (row.on ? !perms.canLaunch : !perms.canActivate)
        return NO_PERM_TITLE;
    return null;
}
/**
 * Тумблер «В Meta»: включён — пауза, выключен — включение, оба через те же
 * диалоги проверки. Сам тумблер не «перещёлкивается»: он показывает статус из
 * Meta и меняется после ответа (список перечитывается). Объекты конструктора
 * управляются так же — кампания делегируется запуску на стороне сервера.
 */
export function MetaToggle({ row, h }) {
    const perms = useAdsCampaignsPerms();
    const blocked = toggleBlockedReason(row, h, perms);
    const sw = (_jsx(Switch, { checked: row.on, disabled: blocked !== null, "aria-label": `${row.on ? 'Поставить на паузу' : 'Включить'}: «${row.name}»`, onCheckedChange: () => (row.on ? h.onPause(row) : h.onEnable(row)) }));
    if (row.gone)
        return _jsx("span", { className: "text-sm text-[var(--color-text-muted)]", children: "\u2014" });
    if (row.managed && !h.delegation)
        return (_jsx(Hint, { content: "\u0421\u043E\u0437\u0434\u0430\u043D\u0430 \u0437\u0430\u043F\u0443\u0441\u043A\u043E\u043C \u2014 \u043F\u0430\u0443\u0437\u043E\u0439 \u0438 \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u043C \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u0442 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u0437\u0430\u043F\u0443\u0441\u043A\u0430.", children: _jsx("span", { className: "text-sm text-[var(--color-text-muted)]", tabIndex: 0, children: "\u2014" }) }));
    return blocked ? (_jsx(Hint, { content: blocked, children: _jsx("span", { className: "inline-flex", tabIndex: 0, children: sw }) })) : (sw);
}
/** Меню «⋯» строки: дублировать, скопировать ID, открыть в Ads Manager, открыть запуск. */
export function RowMenu({ row, h }) {
    return (_jsxs(RowActionsMenu, { "aria-label": `Действия: «${row.name}»`, children: [row.kind === 'campaign' ? (_jsx(DropdownMenu.Item, { asChild: true, children: _jsx(Link, { to: '/fb-launches/new', search: { duplicateFrom: row.id, account: h.accountId }, children: "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u2026" }) })) : null, _jsxs(RowActionsMenu.Item, { onSelect: () => void copyId(row.id), children: ["\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C ID ", KIND_LABEL[row.kind]] }), _jsx(DropdownMenu.Item, { asChild: true, children: _jsx("a", { href: adsManagerHref(h.adAccountId, row.kind, row.id), target: "_blank", rel: "noopener noreferrer", children: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0432 Ads Manager \u2197" }) }), row.managed ? (_jsx(DropdownMenu.Item, { asChild: true, children: _jsx(Link, { to: launchPageHref(row.managed.launchId), children: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0437\u0430\u043F\u0443\u0441\u043A" }) })) : null] }));
}
//# sourceMappingURL=row-actions.js.map